import axios from 'axios'

export function fetchEntities (onlyActive = true) {
  const params = {
    page_size: 0
  }
  if (onlyActive) params.active = true
  return axios.get('/api/entities/', { params })
}
